import { render } from "./bottomrow.vue?vue&type=template&id=a64513bc&scoped=true"
import script from "./bottomrow.vue?vue&type=script&lang=js"
export * from "./bottomrow.vue?vue&type=script&lang=js"

import "./bottomrow.vue?vue&type=style&index=0&id=a64513bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a64513bc"]])

export default __exports__